import { AnyAction } from 'redux';
import { SagaIterator } from 'redux-saga';
import { call, put, takeLatest } from 'redux-saga/effects';
import { getAdminProductGroups } from 'src/api/article-management';
import {
    FETCH_ADMIN_PRODUCT_GROUPS,
    requestAdminProductGroups,
    requestAdminProductGroupsFailure,
    requestAdminProductGroupsSuccess,
} from './actions';

function* fetchAdminProductGroupsSaga(action: AnyAction): SagaIterator {
    yield put(requestAdminProductGroups());

    const { error, response } = yield call(getAdminProductGroups);

    if (error) {
        yield put(requestAdminProductGroupsFailure(error));
    } else {
        yield put(requestAdminProductGroupsSuccess(response));
    }
}

export function* generateFetchAdminProductGroupWatcher() {
    yield takeLatest(FETCH_ADMIN_PRODUCT_GROUPS, fetchAdminProductGroupsSaga);
}
